import httpService from '../Api/http.service';
import { getApiBaseUrl } from 'utils';

const getGeocode = (address) => {
  return httpService({
    url: `${getApiBaseUrl()}/mgt/geocode?address='${address}'`,
    method: 'get',
  });
};
const userService = {
  getGeocode,
};

export default userService;
